var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1.5C5.0074 1.66822 4.77679 1.83647 4.57591 1.98404C4.175 2.27864 3.63798 2.68421 3.09898 3.12483C2.56343 3.56261 2.00976 4.04799 1.58448 4.50114C1.37257 4.72693 1.17767 4.96035 1.03193 5.18795C0.897847 5.39737 0.75 5.68515 0.75 5.99997C0.75 6.3148 0.897847 6.60264 1.03193 6.81206C1.17767 7.03966 1.37257 7.27302 1.58448 7.49884C2.00976 7.95199 2.56343 8.43735 3.09898 8.87517C3.63798 9.31576 4.175 9.72131 4.57591 10.016C4.77679 10.1635 5.0074 10.3318 5.24999 10.5",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/arrow-prev.807a73d8b3178f92e2fad870103679ab.svg";
export { ForwardRef as ReactComponent };